// extracted by mini-css-extract-plugin
module.exports = {"trendSection":"trendStyles_trendSection__2rbG6","header":"trendStyles_header__NNbk8","body":"trendStyles_body__9N0TY","download":"trendStyles_download__3744_"};